<div class="card-content consent-form-content">
  <h1 class="card-title">{{ 'consent-form.title' | translate }}</h1>

  <form [formGroup]="consentForm" (ngSubmit)="onSubmit()">
      
    <div class="input-block">
      <span>{{ 'consent-form.remind-text' | translate }}</span>
      <span>{{ 'consent-form.short-text' | translate }}</span>

      <ul class="consent-form-list">
        <li>{{ 'consent-form.short-text-1' | translate }}</li>
        <li>{{ 'consent-form.short-text-2' | translate }}</li>
        <li>{{ 'consent-form.short-text-3' | translate }}</li>
        <li>{{ 'consent-form.short-text-4' | translate }}</li>
      </ul>

      <span>{{ 'consent-form.short-text-content' | translate }}
        <button mat-button class="btn-text-primary" (click)="openPrivacyPolicy()">{{ 'consent-form.short-text-button' | translate }}</button>
        。
      </span>
    </div>


    <div class="input-block consent-form-check">
      <mat-checkbox formControlName="agreeChecked">
        {{ 'consent-form.short-text-check' | translate }}
      </mat-checkbox>
    </div>

    <button mat-button type="submit" class="btn-fill-primary btn-size-l" [disabled]="!agreeChecked">
      {{ 'consent-form.next' | translate }}
    </button>
  </form>
</div>
